import React, { useState, useMemo } from "react";
import ParagraphTag from "../reusebale/Paragraph";
import ButtonTag from "../reusebale/button";
import db from "../../db/index.json";
import { X } from "lucide-react";
import MyLoader from "../reusebale/myLoader";
import LabelTag from "../reusebale/label";

const TerminationPopUp = ({ onClose, onSubmit, loading }) => {
  const { popupData } = db;

  const [reason, setReason] = useState("");
  const [refund, setRefund] = useState("");
  const [securityDepositRefund, setSecurityDepositRefund] = useState("");

  // Handle numeric input only
  const handleNumericInput = (value, setter) => {
    // Remove all non-numeric characters except decimal point
    let numericValue = value.replace(/[^0-9.]/g, "");
    // Prevent multiple decimal points
    const parts = numericValue.split(".");
    if (parts.length > 2) {
      numericValue = parts[0] + "." + parts.slice(1).join("");
    }
    setter(numericValue);
  };

  // Calculate total amount
  const totalAmount = useMemo(() => {
    const refundNum = parseFloat(refund) || 0;
    const securityDepositNum = parseFloat(securityDepositRefund) || 0;
    return refundNum + securityDepositNum;
  }, [refund, securityDepositRefund]);

  const handleSubmit = () => {
    onSubmit(reason, refund, securityDepositRefund, totalAmount);
  };

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[25%] bg-white shadow rounded-[31px] mx-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <ParagraphTag
            content="Lease Termination"
            classes={`text-darkColor font-popinsSemiBold text-base `}
          />
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div>
          <LabelTag
            isStaric={false}
            name="Reason"
            classes="!text-xs !font-popinsMedium"
          />
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            type="text"
            cols={10}
            placeholder="Please enter your reason"
            className="w-full h-28 mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-lg text-darkColor placeholder:text-zinc-700/50"
          ></textarea>
        </div>
        <div className="mt-2">
          <LabelTag
            isStaric={false}
            name="Amount"
            classes="!text-xs !font-popinsMedium"
          />
          <input
            type="text"
            inputMode="decimal"
            value={refund}
            onChange={(e) => handleNumericInput(e.target.value, setRefund)}
            onKeyDown={(e) => {
              if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.preventDefault();
              }
            }}
            placeholder="e.g. 100"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="mt-2">
          <LabelTag
            isStaric={false}
            name="Security Deposit Refund"
            classes="!text-xs !font-popinsMedium"
          />
          <input
            type="text"
            inputMode="decimal"
            value={securityDepositRefund}
            onChange={(e) => handleNumericInput(e.target.value, setSecurityDepositRefund)}
            onKeyDown={(e) => {
              if (!/[0-9.]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.preventDefault();
              }
            }}
            placeholder="e.g. 100"
            className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
          />
        </div>

        <div className="mt-2">
          <div className="flex justify-between items-center">
            <LabelTag
              isStaric={false}
              name="Total Amount"
              classes="!text-xs !font-popinsMedium"
            />
            <div className="text-lg font-popinsSemiBold text-darkColor">
              ${totalAmount.toFixed(2)}
            </div>
          </div>
        </div>

        <div className="w-full mt-6">
          {loading ? (
            <div className="flex justify-center items-center">
              <MyLoader />
            </div>
          ) : (
            <ButtonTag
              name={"Submit"}
              onSubmit={handleSubmit}
              classes="w-full text-base text-center border-2 border-themeColor text-white bg-themeColor"
            />
          )}
        </div>
      </section>
    </main>
  );
};

export default TerminationPopUp;
